<template>
  <section class="my-15">
    <v-container
      id="container"
      class="d-flex align-center justify-center"
    >
      <v-row class="fill-height" align="center" justify="center">
        <v-col
          cols="12"
          md="4"
          v-for="(card,i) in proyectos"
          :key="i"
          class="d-flex align-center justify-center pa-1 ma-0"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              color="lighten-4"
              width="100%"
              class="ma-0 pa-0"
              :class="{ 'on-hover': hover }"
              :elevation="hover ? 12 : 2"
            >
              <router-link class="text-decoration-none" :to="card.path">
                <v-img contain :src="card.img">
                  <v-row class="fill-height" justify="center" align="center">
                    <v-col>
                      <div align="center">
                        <img contain height="100" :src="card.ico" />
                      </div>
                    </v-col>
                  </v-row>
                </v-img>
              </router-link>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Proyectos",
  data: () => ({
    transparent: "rgba(255, 255, 255, 0)",
    proyectos: [
      {
        ico: require("@/assets/logos/ebersy.svg"),
        img: require("@/assets/img/proyectos/ebersy.png"),
        path: "/ebersy",
      },
      {
        ico: require("@/assets/logos/gr.svg"),
        img: require("@/assets/img/proyectos/gr.png"),
        path: "/generarecetas",
      },
      {
        ico: require("@/assets/logos/gestiongr.svg"),
        img: require("@/assets/img/proyectos/gestiongr.jpg"),
        path: "/gestiongr",
      },
      {
        ico: require("@/assets/logos/tikgestion.svg"),
        img: require("@/assets/img/proyectos/tik.png"),
        path: "/tikgestion",
      },
      {
        ico: require("@/assets/logos/pariciones.svg"),
        img: require("@/assets/img/proyectos/pariciones.png"),
        path: "/pariciones",
      },

      {
        ico: require("@/assets/logos/toi.svg"),
        img: require("@/assets/img/proyectos/toi.png"),
        path: "/toi",
      },
    ],
  }),
};
</script>

<style scoped>
#container {
  min-height: calc(100vh - 74px);
}

.card {
  min-height: 30vh;
}
.v-card {
  transition: opacity 0.2s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
